import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '../../../../../../../../components/forms/Buttons/Button';
import SimpleLoader from '../../../../../../../../components/Loader/SimpleLoader';
import { deleteFormContentQuestion } from '../../../../../../../../services/forms/formContentQuestionService';
import { useFormEdit } from '../../../../FormEditContext';

export default function OptionBlank({
  children,
  field,
  fields,
  setFields,
  update,
  selected,
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { reportError } = useFormEdit();

  return (
    <div className='flex w-full flex-row gap-2'>
      {children}
      {field.is_correct && (
        <CheckIcon className='h-5 text-success' title='correct answer' /> // to translate
      )}
      {fields?.length > 1 &&
        selected &&
        (isDeleting ? (
          <div className='relative '>
            <SimpleLoader className='h-4' />
          </div>
        ) : (
          <XMarkIcon
            title={'Remove'} // to translate
            className='h-5 cursor-pointer'
            onClick={() => {
              // Спиннер — только пока идёт сам запрос, отмена его не трогает.
              toast.dark(
                ({ closeToast }) => (
                  <div>
                    <div>Удалить вариант «{field.content}»?</div>
                    <div className='mt-3 flex justify-center gap-3'>
                      <Button
                        text={'Да'}
                        color='error-solid'
                        onClick={() => {
                          closeToast();
                          setIsDeleting(true);
                          deleteFormContentQuestion(field?.uuid)
                            ?.then(() => {
                              setFields((prev) =>
                                prev.filter((f) => {
                                  return field.uuid !== f.uuid;
                                }),
                              );
                              //   update();
                            })
                            ?.catch((err) => {
                              reportError(
                                err,
                                `Не удалось удалить вариант «${field.content}»`,
                              );
                            })
                            ?.finally(() => {
                              setIsDeleting(false);
                            });
                        }}
                      />
                      <Button
                        text={'Нет'}
                        className='text-white'
                        onClick={closeToast}
                      />
                    </div>
                  </div>
                ),
                {
                  toastId: `delete-option-${field.uuid}`,
                  autoClose: false,
                  closeButton: true,
                },
              );
            }}
          />
        ))}
    </div>
  );
}
